export const FILTER_ENTITY_TYPES = {
  ACCOUNT: "account",
  OPPORTUNITY: "opportunity",
  TOUCHPOINT: "touchpoint",
  CAMPAIGN: "campaign",
} as const;

export type FilterEntityType =
  (typeof FILTER_ENTITY_TYPES)[keyof typeof FILTER_ENTITY_TYPES];
